module.exports = __webpack_public_path__ + "img/jins4.29141b6a.jpg";